import BlogCard from '@components/BlogCard';

function BlogCards({ articles }) {
  return (
    <div className='eye:grid eye:grid-cols-1 eye:sm:grid-cols-2 eye:xl:grid-cols-4 eye:gap-xs'>
      {articles.map((article) => (
        <BlogCard
          key={article.title + article.to}
          description={article.description}
          image={article.image}
          title={article.title}
          to={article.to}
        />
      ))}
    </div>
  );
}

export default BlogCards;
